import { Minus, Plus } from '@components/icons'
import cn from 'clsx'
import React, { FC } from 'react'
import s from './Quantity.module.css'
export interface QuantityProps {
  value: number
  increase: () => any
  decrease: () => any
  handleRemove?: React.MouseEventHandler<HTMLButtonElement>
  isDiscountedProduct?: boolean
  isMaximumQuantity?: boolean
  showRemove?: boolean
}

const Quantity: FC<QuantityProps> = ({
  value,
  increase,
  decrease,
  handleRemove,
  isDiscountedProduct,
  isMaximumQuantity,
  showRemove,
}) => {
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row ml-[1px] mb-[5px]">
        {value > 1 && (
          <>
            {isDiscountedProduct && (
              <>
                <button type="button" onClick={decrease} disabled={value <= 1}>
                  <Minus width={13} />
                </button>
                <span className={s.quantityNumber}>{value}</span>

                <button
                  type="button"
                  onClick={increase}
                  className={cn({
                    [s.quantityDisabled]: isMaximumQuantity,
                  })}
                  disabled={value < 1}
                >
                  <Plus width={13} />
                </button>
              </>
            )}
          </>
        )}

        {isDiscountedProduct ? (
          <button
            type="button"
            onClick={decrease}
            className={s.discount}
            disabled={value <= 1}
          >
            <Minus width={13} />
          </button>
        ) : (
          <>
            <button type="button" onClick={decrease} disabled={value <= 1}>
              <Minus width={13} />
            </button>
            <span className={s.quantityNumber}>{value}</span>
            <button
              type="button"
              onClick={increase}
              className={cn({
                [s.quantityDisabled]: isMaximumQuantity,
              })}
              disabled={value < 1}
            >
              <Plus width={13} />
            </button>
          </>
        )}
        <></>
      </div>
      {showRemove && (
        <button className={s.remoteBtn} onClick={handleRemove}>
          Remove
        </button>
      )}
    </div>
  )
}

export default Quantity
